(function($) {
	$(function () {

        $('.js-accordion').each(function () {
            initAccordion($(this))
        })

        function initAccordion($accordion) {
            const $trigger = $accordion.find('.js-accordion-trigger')
            const $explore = $accordion.closest('.js-explore')
            const $exploreImg = $explore.find('.js-explore-img')
            $trigger.on('click', function() {
                const $currentTrigger = $(this)
                const $curenntItem = $currentTrigger.closest('.js-accordion-item')
                $curenntItem.find('.js-accordion-item-content').stop().slideDown()
                $curenntItem.siblings()
                    .find('.js-accordion-item-content')
                    .stop().slideUp()

                const index = $curenntItem.data('index')
                $exploreImg.removeAttr('data-active')
                $exploreImg.eq(index).attr('data-active', true)
            })
        }

	})
})(window.jQuery)
